import { render, staticRenderFns } from "./DlgSelectGrpLABForViewTable.vue?vue&type=template&id=232618e5"
import script from "./DlgSelectGrpLABForViewTable.vue?vue&type=script&lang=js"
export * from "./DlgSelectGrpLABForViewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports